import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "trash", "videoPreview"];
  static values = {
    video: String,
  };

  connect() {
    const trashIcon = this.trashTarget;
    this.videoPreviewTarget.src = this.videoValue;
    const scope = this;

    trashIcon.addEventListener("click", function (e) {
      scope.setRemoveVideoInput("true");
      e.preventDefault();
    });
  }

  setRemoveVideoInput(value) {
    this.videoPreviewTarget.src = '';
  }

  chooseFile() {
    this.inputTarget.click();
  }
  fileChosen(event) {
    const target = this.videoPreviewTarget;
    this.fileToDataUrl(event, (src) => (target.src = src));
  }

  fileToDataUrl(event, callback) {
    if (!event.target.files.length) return;

    let file = event.target.files[0],
        reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = (e) => (callback(e.target.result));
  };
};
